export const URL_BACKEND = `https://cms.121latam.com/api`;
// export const URL_BACKEND = `https://121-admin-production.up.railway.app/api` //TESTING
